import { mapGetters, mapActions } from 'vuex'
import { Promise } from 'q'
export default {
  data () {
    return {
      industryData: undefined,
      deleteArray: [],
      form: {
        industrySecondType: '',
        isEdit: true
      },
      donewsStatus: '0',
      accountinfo: {
        commonForm: {
          industrySecondMenu: [],
          industryMenu: [],
        },
        form: {
          industrySecondMenu: [],
          industryMenu: []
        },
        formList: {
          industrySecondMenu: [],
          industryMenu: []
        }
      },
      industryDisabled: false,
      formList: {
        industrySecondType: '',
        industryType: '',
        loading: false
      },
      isAddFirst: false,
      mediaTab: '1',
      commonForm: {
        industryType: '',
        industrySecondType: '',
        committing: false,
        isEdit: false,
        loading: false,
        auditMsg: ['', '', '小米', '掌阅'],
        xiaomi: {
          industryType: '',
          industrySecondType: '',
        },
        zhangyue: {
          industryType: '',
          industrySecondType: '',
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'login/user',
      adType: 'login/adType',
      subAccount: 'subAccount/subAccount'
    })
  },
  async mounted () {
    await this.industryInte()
  },
  methods: {
    ...mapActions([
      'global/subAccount/getIndustryMenu',
      'global/subAccount/getIndustryDetails',
      'global/subAccount/getQualification',
      'global/subAccount/getIndustryAgencyDetails',
      'global/subAccount/submitIndustry',
      'global/subAccount/deleteIndustry',
      'global/subAccount/getVerify'
    ]),
    async industryInte () {
      await this.getIndustryMenu({ type: 0 })
      // await this.getAccountInfo()
      // await this.getIndustryDetails()
      // console.log(this.getIndustryDetails())
    },
    async handleClick ({ platform } = {}) {
      this.deleteArray = []
      let arr = ['', 'form', 'commonForm', 'commonForm']
      let mediaType = arr[this.mediaTab]
      let userID = platform === 'advertiser' ? this.user.id : this.userid

      if (platform === 'advertiser' && this.mediaTab !== '1') {
        await this.getVerifyData()
      }
      this.industrySwitch(this.mediaTab)
      await this.getIndustryMenu({ type: 0, form: mediaType })
      if (this[mediaType].isEdit) {
        await this.getIndustryMenu({ type: this[mediaType].industryType, form: mediaType })
      }
      this.getIndustryDetails(this.isAgency, userID, mediaType)
    },
    industrySwitch (media) {
      switch (media) {
        case '2':
          this.commonForm = { ...this.commonForm, ...this.commonForm.xiaomi }
          break;
        case '3':
          this.commonForm = { ...this.commonForm, ...this.commonForm.zhangyue }
          break;
      }
      this.commonForm.isEdit = this.commonForm.industrySecondType !== ''
    },
    async getVerifyData () {
      let verifyData = await this['global/subAccount/getVerify']({
        request: this.post,
        type: this.mediaTab,
        params: {
          account_id: this.userid
        }
      })
      this.verify.auditStatus = verifyData.verify
      this.verify.auditReason = verifyData.reason ? verifyData.reason.msg : ''
      this.titleShow.verify = true
      if (this.verify.auditStatus === 1) {
        if (!verifyData.first_pass) {
          this.titleShow.verify = false
        }
        setTimeout(() => {
          this.titleShow.verify = false
        }, 10000)
      }
    },
    async changeIndustry ({ value, form, isEdit }) {
      if (!isEdit) {
        this[form].industrySecondType = ''
      }
      await this.getIndustryMenu({ type: value, form })
    },
    async changeIndustrySecondType ({ value, form, platform }) {
      let userID = platform === 'advertiser' ? this.user.id : this.userid
      this.getIndustryDetails(this.isAgency, userID, form)
    },
    async getIndustryDetails (isAgency, userid = this.userid, form = 'form') {
      let details
      this[form].loading = true
      details = await this['global/subAccount/getIndustryDetails']({
        request: this.get,
        user_id: userid,
        type: this.mediaTab
      })
      if (details.length < 1) {
        this.isAddFirst = true
        if (isAgency) {
          details = await this['global/subAccount/getIndustryAgencyDetails']({
            request: this.get,
            user_id: userid,
            type: this.mediaTab
          })
        } else {
          details = await this['global/subAccount/getQualification']({
            request: this.get,
            id: this[form].industrySecondType,
            type: this.mediaTab
          })
        }
      }
      this[form].loading = false
      this.industryData = details
    },
    async getIndustryMenu ({ type, form = 'form' }) {
      let menu = await this['global/subAccount/getIndustryMenu']({
        request: this.get,
        id: type,
        type: this.mediaTab
      })
      let menuKey = type === 0 ? 'industryMenu' : 'industrySecondMenu'
      this.accountinfo[form][menuKey] = menu
    },
    filterIndustry () {
      var data
      data = this.industryData.filter((item, index) => {
        if (item.qualification_id === 0) {
          let s = Object.keys(item).some(v => {
            if (typeof item[v] === 'object') {
              return item[v].some(k => {
                return k
              })
            } else {
              return item[v]
            }
          })
          if (s) {
            return item
          }
        } else {
          return item
        }
      })
      return data
    },
    async submitIndustry ({ userid = this.userid, form }) {
      let request = this.isAddFirst ? this.post : this.patch
      let uid = this.isAddFirst ? '' : userid
      return await this['global/subAccount/submitIndustry']({
        request: request,
        userid: uid,
        type: this.mediaTab,
        params: {
          industry_id: this[form].industrySecondType,
          user_id: userid,
          data: JSON.stringify(this.filterIndustry())
        }
      })
    },
    async submitDelete () {
      return await this['global/subAccount/deleteIndustry']({
        request: this.remove,
        type: this.mediaTab,
        id: this.deleteArray.join(',')
      })
    },
    submitMediaForm (form, platform) {
      this.$refs[form].validate((valid) => {
        this.$refs.industry.$refs.industryForm.validate((validIn) => {
          if (valid && validIn) {
            this[form].committing = true;
            let userID = platform === 'advertiser' ? this.user.id : this.userid
            let promiseArr = [
              this.submitIndustry({ form, userid: userID })
            ]
            if (this.deleteArray.length > 0) {
              promiseArr.push(this.submitDelete())
            }
            Promise.all(promiseArr).then(data => {
              let suc = data.every(res => {
                if (res.code !== 1) {
                  this[form].committing = false;
                  this.$message.error(res.msg)
                }
                return res.code === 1
              })
              if (suc) {
                this.$confirm('编辑成功！', '提示', {
                  confirmButtonText: '确定',
                  showCancelButton: false,
                  callback: () => {
                    if (platform === 'advertiser') {
                      this[form].committing = false
                      this.$router.push('accountInfo')
                    } else {
                      this.$router.push('/userList');
                    }
                  },
                  type: 'success'
                });
              }
            }).catch(() => {
              this[form].committing = false
            })
          }
        })
      })
    }
  }
}
